import Titulo from '../../../components/tipografia/Titulo';
import LayoutUsuario from '../../../components/navegacao/LayoutUsuario';
import Descricao from '../../../components/tipografia/Descricao';
import HBox from '../../../components/layout/HBox';
import VBox from '../../../components/layout/VBox';
import Grid, { GridItem } from '../../../components/layout/Grid';
import CampoSeletor from '../../../components/Formulario/CampoSeletor';
import CampoData from '../../../components/Formulario/CampoData';
import { useState } from 'react';
import { format, startOfWeek, endOfWeek, startOfMonth, endOfMonth, startOfYear, endOfYear } from 'date-fns';
import {
  PERIODO_RELATIVO_OPTIONS,
  resolvePeriodoRelativo,
  PeriodoRelativoToken,
} from '../util';
import CardTotalFinanceiro from './CardTotalFinanceiro';
import CardSerieFinanceira from './CardSerieFinanceira';
import CardDespesasPorCategoria from './CardDespesasPorCategoria';
import CardContasAVencer from './CardContasAVencer';
import CardComparativoMensal from './CardComparativoMensal';
import CardRelatorioTotalAtendimentos from '../CardRelatorioTotalAtendimentos';

// resolvePeriodoRelativo trunca "semana"/"mes"/"ano" no dia de hoje (correto para
// relatórios de atividade histórica). Lançamentos financeiros têm data de
// vencimento futura (contas a vencer, receitas agendadas), então aqui o
// período precisa ir até o fim do intervalo, não até hoje.
const resolvePeriodoFinanceiro = (
  periodoToken: PeriodoRelativoToken,
  customInicio: string,
  customFim: string,
) => {
  const hoje = new Date();
  const fmt = (d: Date) => format(d, 'yyyy-MM-dd');

  switch (periodoToken) {
    case 'semana':
      return {
        dataInicio: fmt(startOfWeek(hoje, { weekStartsOn: 0 })),
        dataFim: fmt(endOfWeek(hoje, { weekStartsOn: 0 })),
      };
    case 'mes':
      return { dataInicio: fmt(startOfMonth(hoje)), dataFim: fmt(endOfMonth(hoje)) };
    case 'ano':
      return { dataInicio: fmt(startOfYear(hoje)), dataFim: fmt(endOfYear(hoje)) };
    default:
      return resolvePeriodoRelativo(periodoToken, customInicio, customFim);
  }
};

const RelatorioFinanceiroPage = () => {
  const [periodoToken, setPeriodoToken] = useState<PeriodoRelativoToken>('mes');
  const [customInicio, setCustomInicio] = useState<string>('');
  const [customFim, setCustomFim] = useState<string>('');

  const { dataInicio, dataFim } = resolvePeriodoFinanceiro(
    periodoToken,
    customInicio,
    customFim,
  );

  return (
    <LayoutUsuario>
      <VBox gap="8px">
        <HBox>
          <VBox style={{ flex: 1 }}>
            <Titulo>Relatório financeiro</Titulo>
            <Descricao>
              Entradas, saídas e saldo do período, com detalhamento por categoria.
            </Descricao>
          </VBox>
        </HBox>

        <Grid>
          <GridItem sm={12} md={6} lg={4}>
            <HBox>
              <CampoSeletor
                noSearch
                options={PERIODO_RELATIVO_OPTIONS as unknown as { id: string; label: string }[]}
                placeholder="Filtrar por período"
                value={periodoToken}
                onChange={value => setPeriodoToken(value as PeriodoRelativoToken)}
                style={{ width: '100%', flex: 1 }}
              />
              {periodoToken === 'custom' && (
                <>
                  <CampoData
                    placeholder="Data inicial"
                    value={customInicio}
                    onChange={setCustomInicio}
                  />
                  <CampoData
                    placeholder="Data final"
                    value={customFim}
                    onChange={setCustomFim}
                  />
                </>
              )}
            </HBox>
          </GridItem>
        </Grid>

        <Grid>
          <GridItem sm={12} md={4} lg={3} p={4}>
            <CardTotalFinanceiro
              titulo="Total de entradas"
              fact="total_entradas"
              dataInicio={dataInicio}
              dataFim={dataFim}
              cor="#22c55e"
            />
          </GridItem>
          <GridItem sm={12} md={4} lg={3} p={4}>
            <CardTotalFinanceiro
              titulo="Total de saídas"
              fact="total_saidas"
              dataInicio={dataInicio}
              dataFim={dataFim}
              cor="#7339ac"
            />
          </GridItem>
          <GridItem sm={12} md={4} lg={3} p={4}>
            <CardTotalFinanceiro
              titulo="Saldo"
              fact="saldo"
              dataInicio={dataInicio}
              dataFim={dataFim}
            />
          </GridItem>
          <GridItem sm={12} md={12} lg={3} p={4}>
            <CardRelatorioTotalAtendimentos
              periodo={['custom', dataInicio, dataFim]}
              canal_id={[]}
              style={{ height: '105px' }}
            />
          </GridItem>
        </Grid>

        <Grid>
          <GridItem sm={12} lg={8} p={6}>
            <CardSerieFinanceira dataInicio={dataInicio} dataFim={dataFim} />
          </GridItem>
          <GridItem sm={12} lg={4} p={6}>
            <CardDespesasPorCategoria dataInicio={dataInicio} dataFim={dataFim} />
          </GridItem>
        </Grid>

        <Grid>
          <GridItem sm={12} md={6} lg={4} p={4}>
            <CardContasAVencer />
          </GridItem>
          <GridItem sm={12} md={6} lg={4} p={4}>
            <CardComparativoMensal />
          </GridItem>
        </Grid>
      </VBox>
    </LayoutUsuario>
  );
};

export default RelatorioFinanceiroPage;
